import React, { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormInputText from '../../../common/Forms/FormTextField';
import FormInputDropdown from '../../../common/Forms/FormDropdown';
import { useForm, useWatch } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import {
  dateFormat,
  EPISODE_2284_REFERENCE_DATA_URL,
  EPISODE_AOR_URL,
  fieldRequired,
  formDateFormat,
} from '../../../../constants';
import {
  setCaseManagerOrParoleAgent,
  setEndDate,
  setRecordEpdCntID,
  setRoleType,
  setStartDate,
} from '../../../../redux/episode/aorvmTab/episodeAorcmSlice';
import { postStopApi, setStopApi } from '../../../../services/StopApi/StopApi';
import FormSuccess from '../../../common/Forms/FormSuccess';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
//import _ from 'lodash';
import { setRefreshEpisodeParticipant } from '../../../../redux/episode/episodeParticipant/episodeParticipantSlice';
import {
  DialogHeader,
  DialogHeading,
  ButtonWrapper,
  CancelButton,
  SaveButton,
} from '../../Episode.Styled';
import { get2284ReferenceData } from '../../../../redux/episode/2284Tab/2284Reference/2284ReferenceSlice';

const emptyOptions = [
  {
    id: '',
    value: '',
  },
];
const schema = yup.object().shape({
  startDate: yup.date().typeError(fieldRequired).required(),
  //endDate: yup.date().typeError(fieldRequired).required(),
  roleType: yup.string().required(fieldRequired),
  caseManagerOrParoleAgent: yup.string().required(fieldRequired),
});

function AorcmDialog(props) {
  const dispatch = useDispatch();
  const { open, setOpen, authToken, episodeId, openBackdrop, fetchData } =
    props;
  const aorcmReferenceData = useSelector((state) => state.aorcmReferenceData);
  const aorcmFormData = useSelector((state) => state.episodeAorcm);
  const [formSuccess, setFormSuccess] = useState(false);
  const [isNewAorcm, setIsNewAorcm] = useState(false);

  const defaultValue = {
    recordEpdCntID: aorcmFormData?.recordEpdCntID,
    startDate: moment(aorcmFormData?.startDate)
      .format(formDateFormat)
      .split('T')[0],
    endDate: moment(aorcmFormData?.endDate)
      .format(formDateFormat)
      .split('T')[0],
    roleType: aorcmFormData?.roleType?.value
      ? aorcmFormData?.roleType?.value
      : '',
    caseManagerOrParoleAgent: aorcmFormData?.caseManagerOrParoleAgent?.value
      ? aorcmFormData?.caseManagerOrParoleAgent?.value
      : '',
  };
  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(schema),
  });
  const { handleSubmit, reset, control, setValue, watch, register, formState } =
    useFunction;
  const { isValid, dirtyFields, errors } = formState;

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue.recordEpdCntID,
    defaultValue.startDate,
    defaultValue.endDate,
    defaultValue.caseManagerOrParoleAgent,
    defaultValue.roleType,
  ]);

  const roleType = useWatch({
    control,
    name: 'roleType',
  });
  const roleTypeIds = aorcmReferenceData?.roleList?.filter((item) =>
    item.value === roleType ? item.id : ''
  );
  const roleTypeValues = {
    id: roleTypeIds[0]?.id,
    value: roleTypeIds[0]?.value,
  };

  const caseManagerOrParoleAgent = useWatch({
    control,
    name: 'caseManagerOrParoleAgent',
  });
  let caseManagerDropDown = '';
  switch (aorcmFormData?.roleType?.value) {
    case 'Case Manager/CM     ':
      caseManagerDropDown = aorcmReferenceData?.caseManagerOrCMList;
      break;
    case 'Parole Agent/AOR    ':
      caseManagerDropDown = aorcmReferenceData?.paroleAgentOrAORList;
      break;
    case 'Placement Coord.    ':
      caseManagerDropDown = aorcmReferenceData?.placementCoordinateList;
      break;
    case '':
      caseManagerDropDown = emptyOptions;
      break;
    case null:
      caseManagerDropDown = emptyOptions;
      break;
    case undefined:
      caseManagerDropDown = emptyOptions;
      break;
  }
  const caseManagerOrParoleAgentIds = caseManagerDropDown?.filter((item) =>
    item.value === caseManagerOrParoleAgent ? item.id : ''
  );
  const caseManagerOrParoleAgentValues = {
    id: caseManagerOrParoleAgentIds ? caseManagerOrParoleAgentIds[0]?.id : '',
    value: caseManagerOrParoleAgentIds
      ? caseManagerOrParoleAgentIds[0]?.value
      : '',
  };

  useEffect(() => {
    dispatch(setRoleType(roleTypeValues));
    dispatch(setCaseManagerOrParoleAgent(caseManagerOrParoleAgentValues));
  }, [roleType, caseManagerOrParoleAgent]);

  const fetch2284ReferenceData = () => {
    const reference2284Url = `${EPISODE_2284_REFERENCE_DATA_URL}/${episodeId}`;
    const authorization = authToken;
    dispatch(get2284ReferenceData({ reference2284Url, authorization }));
  };

  const handleClose = () => {
    setOpen(false);
    reset(defaultValue);
  };

  const onSubmit = () => {
    const url = `${EPISODE_AOR_URL}/${episodeId}/AORCMs`;
    const authorization = authToken;
    const payload = {
      caseManagerOrParoleAgentId: aorcmFormData?.caseManagerOrParoleAgent?.id,
      roleTypeId: aorcmFormData?.roleType?.id,
      recordEpdCntID:
        aorcmFormData?.newAorcm === true ? 0 : aorcmFormData?.recordEpdCntID,
      startDate: aorcmFormData?.startDate,
      endDate: aorcmFormData?.endDate ? aorcmFormData?.endDate : undefined,
    };
    if (aorcmFormData?.newAorcm === true) {
      postStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchData();
          fetch2284ReferenceData();
          setFormSuccess(true);
          setIsNewAorcm(true);
          dispatch(setRefreshEpisodeParticipant(true));
          setTimeout(() => {
            dispatch(setRefreshEpisodeParticipant(false));
          }, 1000);
        }
      }).catch((e) => alert(e));
    } else {
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchData();
          fetch2284ReferenceData();
          setFormSuccess(true);
          setIsNewAorcm(false);
          dispatch(setRefreshEpisodeParticipant(true));
          setTimeout(() => {
            dispatch(setRefreshEpisodeParticipant(false));
          }, 1000);
        }
      }).catch((e) => alert(e));
    }
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: { maxWidth: 'unset', width: '800px', maxHeight: 'unset' },
        }}
      >
        {openBackdrop ? (
          <Backdrop
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={openBackdrop}
          >
            <CircularProgress />
          </Backdrop>
        ) : (
          <>
            <DialogHeader>
              <DialogHeading variant='h5'>AOR/CM Detail</DialogHeading>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </DialogHeader>
            <Grid container spacing={2} style={{ padding: '10px 40px' }}>
              <Grid item xs={12} sm={6}>
                {/* {aorcmFormData?.newAorcm === true ? '' :
                <FormInputText
                  name='recordEpdCntID'
                  control={control}
                  type='text'
                  label='Record EpdCntID'
                  disabled={true}
                  register={register('recordEpdCntID', {
                    onChange: (e) =>
                      dispatch(setRecordEpdCntID(e.target.value)),
                  })}
                />} */}
                <FormInputText
                  name='startDate'
                  control={control}
                  type='date'
                  label='Start Date'
                  maxValue={defaultValue?.endDate}
                  shrink={true}
                  errors={!!errors.startDate}
                  helperText={errors?.startDate?.message}
                  register={register('startDate', {
                    onChange: (e) => dispatch(setStartDate(e.target.value)),
                  })}
                />
                <FormInputText
                  name='endDate'
                  control={control}
                  type='date'
                  label='End Date'
                  shrink={true}
                  minValue={defaultValue?.startDate}
                  errors={!!errors.endDate}
                  helperText={errors?.endDate?.message}
                  register={register('endDate', {
                    onChange: (e) => dispatch(setEndDate(e.target.value)),
                  })}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormInputDropdown
                  name='roleType'
                  control={control}
                  label='Role Type'
                  options={aorcmReferenceData?.roleList}
                  errors={!!errors.roleType}
                  helperText={errors?.roleType?.message}
                />
                <FormInputDropdown
                  name='caseManagerOrParoleAgent'
                  control={control}
                  label='Case Manager or Parole Agent Name'
                  options={caseManagerDropDown}
                  errors={!!errors.caseManagerOrParoleAgent}
                  helperText={errors?.caseManagerOrParoleAgent?.message}
                />
              </Grid>
              <ButtonWrapper>
                <CancelButton
                  variant='contained'
                  //disabled={_.isEmpty(dirtyFields) || !isValid}
                  onClick={handleClose}
                >
                  Cancel
                </CancelButton>
                <SaveButton
                  variant='contained'
                  //style={{ backgroundColor: '#262626' }}
                  // disabled={_.isEmpty(dirtyFields) || !isValid}
                  onClick={handleSubmit(onSubmit)}
                >
                  Save
                </SaveButton>
              </ButtonWrapper>
            </Grid>
          </>
        )}
      </Dialog>
      <FormSuccess
        formSuccess={formSuccess}
        setFormSuccess={setFormSuccess}
        isNewForm={isNewAorcm}
      />
    </>
  );
}

export default AorcmDialog;
